/** Date-only values: local dates for input, UTC day coordinates for arithmetic. */
const DAY_MS = 86_400_000;

export function isoDate(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

export function todayISO(): string { return isoDate(new Date()); }

export function calendarDate(value: string): Date | null {
  const parts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!parts) return null;
  const [, y, m, d] = parts;
  const date = new Date(Number(y), Number(m) - 1, Number(d));
  return isoDate(date) === value ? date : null;
}

export function dateDay(value: string | null | undefined): number | null {
  if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const timestamp = Date.parse(value + "T00:00:00Z");
  return Number.isFinite(timestamp) && new Date(timestamp).toISOString().slice(0, 10) === value ? timestamp / DAY_MS : null;
}

export function dayDate(day: number): Date { return new Date(Math.floor(day) * DAY_MS); }

export function daysBetween(a: string, b: string): number {
  return Math.round((Date.parse(b + "T00:00:00Z") - Date.parse(a + "T00:00:00Z")) / DAY_MS);
}
